import React from 'react';
import { Drawer } from '@noths/polaris-client-ribbons-design-system';
import { ReviewCard } from '@noths/polaris-design-system-candidate-components';
import { Icon } from '@noths/polaris-design-system-core-components';
import type { Review } from '@noths/polaris-design-system-ooux-interfaces';

import * as copy from '../constants/copy';
import * as styles from './CustomersReviewsDrawer.styles';

export interface ReviewDrawerProps {
  /** When the review is read; makes its date relative. */
  date?: Date;
  isOpen: boolean;
  onBack: () => void;
  review: Review;
  /** The list panel's width, so this one sits exactly over it; undefined covers the screen. */
  width?: number;
}

/**
 * The nested panel that shows one review in full: a "Back" control over `ReviewCard`, which
 * owns everything else. A second `Drawer` rather than a swap of the first one's contents,
 * so the list keeps its scroll position and page. react-modal stacks them: the later one
 * takes focus, and Escape closes it, not the list.
 */
export const ReviewDrawer = ({ date, isOpen, onBack, review, width }: ReviewDrawerProps) => (
  <Drawer contentLabel={copy.REVIEW_DRAWER_CONTENT_LABEL} isOpen={isOpen} onRequestClose={onBack}>
    <div css={styles.panel} style={width === undefined ? undefined : { width }}>
      <section css={styles.section}>
        <header css={styles.header}>
          <button css={styles.closeButton} onClick={onBack} type="button">
            <Icon aria-hidden name="actionBack" size="md" />
            {copy.BACK}
          </button>
        </header>
        <div css={styles.reviewContent}>
          <ReviewCard date={date} review={review} />
        </div>
      </section>
    </div>
  </Drawer>
);

ReviewDrawer.displayName = 'ReviewDrawer';
